import { type ComponentPropsWithoutRef, memo } from 'react';

import { Command } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type SearchCommandItemProps = ComponentPropsWithoutRef<typeof Command.Item>;

export const SearchCommandItem = memo(({ className, ...restOfProps }: SearchCommandItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <Command.Item
      className={cn(
        'group/command-item flex cursor-pointer items-center gap-2 rounded-4 p-2 text-14 transition-colors',
        'ads:hover:bg-hover-subtle hover:bg-gray-4 ads:aria-selected:bg-hover-subtle aria-selected:bg-gray-4 ads:data-[selected=true]:bg-hover-subtle data-[selected=true]:bg-gray-4',
        ui2026 && 'min-h-10 gap-3 rounded-12',
        className,
      )}
      data-testid="SEARCH_COMMAND_ITEM"
      {...restOfProps}
    />
  );
});

SearchCommandItem.displayName = 'SearchCommandItem';
